import {Injectable} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {Tunings} from '../../../types/tunings';
import {filter, map} from 'rxjs/operators';
import {select} from '@ngneat/elf';
import {tuningsStore} from './tunings.store';

@Injectable({providedIn: 'root'})
export class TuningsQuery {
  public tunings$: Observable<Partial<Tunings>>;
  public updatedTunings$: Observable<Partial<Tunings>>;
  public tuningsLoading$: Observable<boolean>;
  public tuningsFetched$: Observable<boolean>;

  constructor() {
    this.tunings$ = tuningsStore.pipe(select(state => state.tunings));
    this.updatedTunings$ = tuningsStore.pipe(select(state => state.updatedTunings));
    this.tuningsFetched$ = tuningsStore.pipe(select(state => state.tuningsFetched));
    this.tuningsLoading$ = tuningsStore.pipe(select(state => state.isLoading));
  }

  getLoadedTunings$(): Observable<Partial<Tunings>> {
    return combineLatest([this.tuningsLoading$, this.tuningsFetched$, this.tunings$]).pipe(
      filter(([isLoading, isFetched]) => !isLoading && isLoading !== undefined && isFetched),
      map(([isLoading, isFetched, tunings]) => {
        return tunings;
      }),
    );
  }
}
